module.exports = __webpack_public_path__ + "img/session-expired-popup-01.64c6a39d.webp";